import React from 'react';
import actions from 'roles-actions-permissions/actions';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import { AiFillQuestionCircle } from 'react-icons/ai';
import AppButtonMinimal from '../basic/AppButtonMinimal';
import PermissionsComponent from '../Wrappers/PermissionsComponent';
import BasicField from '../basic/BasicField';
import { useDialog } from '../../dialog-provider-hooks';
import { useAlerts } from '../../hooks/alerts-hooks';
import CollectionItemHeader from '../layout/CollectionItemHeader';
import getTheme from '../../theme/theme';
import { useItems } from '../../hooks/atoms/items-hook';
import CollectionKeys from '../../hooks/molecules/collection-keys';
import AppLoader from '../basic/AppLoader';
import QuestionnairesTable from './questionnaires/QuestionnairesTable';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const Questionnaires = () => {
  const classes = useStyles();

  const { openDialog } = useDialog();
  const { alertSuccess } = useAlerts();

  const {
    itemsLoading: loading,
    count: totalEntries,
    createItem,
  } = useItems(CollectionKeys.QUESTIONNAIRES);

  const handleCreateDialog = () => {
    openDialog({
      title: 'New Questionnaire',
      body({ state, setState }) {
        const setProperty = (property, value) => {
          return setState((prevState) => {
            return { ...prevState, [property]: value };
          });
        };
        return (
          <Grid container>
            <Grid item xs={ 12 }>
              <BasicField
                title='ID'
                field={ state.id }
                onChange={ (v) => { return setProperty('id', v); } }
              />
            </Grid>
            <Grid item xs={ 12 }>
              <BasicField
                title='Name'
                field={ state.name }
                onChange={ (v) => { return setProperty('name', v); } }
              />
            </Grid>
            <Grid item xs={ 12 }>
              <BasicField
                title='Description'
                field={ state.description }
                onChange={ (v) => { return setProperty('description', v); } }
              />
            </Grid>
            <Grid item xs={ 12 }>
              <BasicField
                title='Form ID'
                field={ state.form_id }
                onChange={ (v) => { return setProperty('form_id', v); } }
              />
            </Grid>
          </Grid>
        );
      },
      async onSubmit(s) {
        return createItem(s)
          .then(() => {
            alertSuccess('Questionnaire was successfully created');
          });
      },
    });
  };

  if (loading) {
    return <AppLoader />;
  }
  return (
    <div className={ classes.root }>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <AiFillQuestionCircle
          style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
          size={ 36 }
        />
        <CollectionItemHeader
          title='Questionnaires'
          subtitle={ `Entries: ${ totalEntries }` }
          actions={ (
            <>
              <PermissionsComponent permissions={ actions.VIEW_QUESTIONNAIRE }>
                <AppButtonMinimal
                  text='Create questionnaire'
                  onClick={ () => { return handleCreateDialog(); } }
                />
              </PermissionsComponent>
            </>
          ) }
        />
      </div>
      <QuestionnairesTable />
    </div>
  );
};

export default Questionnaires;
